export class ChartDisplay {
    data!: ChartResultElement[];
    axisMarkers!: string[];
}

export class ChartResultElement {
    name!: string;
    series!: ChartSeries[];
}

export class ChartSeries {
    name!: string;
    value!: number;
}

export class View {
    incrementSize: number;
    incrementUnit: string;
    numberOfUnits: number;
    incrementsPerUnit: number;

    constructor(size: number, unit: string, numUnits: number, incrementsPerUnit: number) {
        this.incrementSize = size;
        this.incrementUnit = unit;
        this.numberOfUnits = numUnits;
        this.incrementsPerUnit = incrementsPerUnit;
    }
}
